export default {
    FROG: {
        id: 1,
        name: "Finn The Frog",
        astronaut: "./Characters/Astronaut_FinnTheFrog.gltf",
        spacecraft: "./Vehicles/Spaceship_FinnTheFrog.gltf",
        planet: "./Envirronment/Planet_1_Frog.gltf",
        mech: "./Characters/Mech_FinnTheFrog.gltf",
        laboratoryColor: "#aaccaa",
        spaceshipColor: "#4c7c26"
    },
    BEE: {
        id: 2,
        name: "Barbara The Bee",
        astronaut: "./Characters/Astronaut_BarbaraTheBee.gltf",
        spacecraft: "./Vehicles/Spaceship_BarbaraTheBee.gltf",
        planet: "./Envirronment/Planet_7_Bee.gltf",
        mech: "./Characters/Mech_BarbaraTheBee.gltf",
        laboratoryColor: "#ccccaa",
        spaceshipColor: "#fbb33d"
    },
    FLAMINGO: {
        id: 3,
        name: "Fernando The Flamingo",
        astronaut: "./Characters/Astronaut_FernandoTheFlamingo.gltf",
        spacecraft: "./Vehicles/Spaceship_FernandoTheFlamingo.gltf",
        planet: "./Envirronment/Planet_8_Flamingo.gltf",
        mech: "./Characters/Mech_FernandoTheFlamingo.gltf",
        laboratoryColor: "#ccaacc",
        spaceshipColor: "#e688be"
    },
    FOX: {
        id: 4,
        name: "Rae The Panda",
        astronaut: "./Characters/Astronaut_RaeTheRedPanda.gltf",
        spacecraft: "./Vehicles/Spaceship_RaeTheRedPanda.gltf",
        planet: "./Envirronment/Planet_10_Fox.gltf",
        mech: "./Characters/Mech_RaeTheRedPanda.gltf",
        laboratoryColor: "#ccaaaa",
        spaceshipColor: "#e39717"
    }
}